import React from "react";

export function Input({ type, placeholder, className, inputProps, error, ...rest }) {
  return (
    <input
      style={{ border: error && "1px solid red" }}
      type={type || "text"}
      placeholder={placeholder}
      className={className}
      {...inputProps}
      {...rest}
    />
  );
}
